import { CaseType } from "src/pages/UserDashboard/WorkPackets/Cases/case-types";

export const CASE_SUPERVISOR_PERMISSIONS: Record<CaseType, string[]> = {
  [CaseType.SHORTAGE_ESCALATION]: ["admin:*", "user:shortages_case:supervisor:*"],
  [CaseType.SHORTAGE_SETTLEMENT]: ["admin:*", "user:shortages_case:supervisor:*"],
  [CaseType.CHARGEBACK_ESCALATION]: ["admin:*", "user:chargebacks_case:supervisor:*"],
};

export const ALL_SUPERVISOR_PERMISSIONS: string[] = [
  "user:shortages_case:supervisor:*",
  "user:chargebacks_case:supervisor:*",
];
